<template>
  <div class="x-handle" @mousedown="mouseDown"></div>
</template>
<script>
export default {
  name: "XHandle",
  data () {
    return {
      lastX: ""
    };
  },

  created () {
    document.addEventListener("mouseup", this.mouseUp);
  },

  destroyed () {
    document.removeEventListener("mouseup", this.mouseUp);
  },

  methods: {
    mouseDown (event) {
      document.addEventListener("mousemove", this.mouseMove);
      this.lastX = event.screenX;
    },
    mouseMove (event) {
      this.$emit("widthChange", this.lastX - event.screenX);
      this.lastX = event.screenX;
      console.log(this.lastX, "...", event.screenX);
    },
    mouseUp () {
      this.lastX = "";
      document.removeEventListener("mousemove", this.mouseMove);
    }
  }
};
</script>
<style lang="less">
.x-handle {
  width: 2px;
  cursor: ew-resize;
  z-index: 999;
  flex-shrink: 0;
  min-height: 180px;
  background: #ccc;
  display: inline-block;
  opacity: 0;
  margin-right: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/materialCenter/components/handle.vue